module.exports = __webpack_public_path__ + "media/images/help-white-1bb6496ca427c8227f5c7c0cea67ebba.png";